"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareTargetPicker = void 0;
var const_1 = require("../const");
var GlobalStore_1 = require("../store/GlobalStore");
var MockDataStore_1 = require("../store/MockDataStore");
var shareTargetPicker = function () {
    if (!GlobalStore_1.globalStore.isInitCalled) {
        throw new Error(const_1.ERROR_MESSAGE.REQUIRE_INIT);
    }
    if (!GlobalStore_1.globalStore.isLoginCalled) {
        throw new Error(const_1.ERROR_MESSAGE.REQUIRE_LOGIN);
    }
    return Promise.resolve(MockDataStore_1.mockStore.getMockData('shareTargetPicker'));
};
exports.shareTargetPicker = shareTargetPicker;
